export { HeaderDefaultDesktop } from './default';
export { HeaderWithCenteredLogoAndNavDesktop } from './withCenteredLogoAndNav';
export { HeaderWithCenteredLogoAndLocatorDesktop } from './withCenteredLogoAndLocator';
export { HeaderWithCenteredLogoAndLocatorFixDesktop } from './withCenteredLogoAndLocatorFix';
export { HeaderWithTopLocatorAndBottomNavDesktop } from './withTopLocatorAndBottomNav';
export { HeaderWithRightStoreLocatorDesktop } from './withRightStoreLocator';
export { HeaderWithCenteredLogoAndBottomContentDesktop } from './withCenteredLogoAndBottomContent';
export { HeaderWithOneLineContentNavRightDesktop } from './withOneLineContentNavRight';
export { HeaderWithOneLineContentNavLeftDesktop } from './withOneLineContentNavLeft';
